import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  animate?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  animate = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50';
  const variants = {
    primary: 'bg-primary text-primary-foreground hover:bg-[#d66522] shadow-md',
    secondary: 'bg-secondary text-secondary-foreground hover:bg-[#234d8a] shadow-md',
    outline: 'border-2 border-primary text-primary hover:bg-primary/10',
    ghost: 'hover:bg-accent hover:text-accent-foreground'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm rounded-full',
    md: 'h-11 px-6 text-base rounded-full',
    lg: 'h-14 px-8 text-lg rounded-full',
    xl: 'h-16 px-10 text-xl rounded-full'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (animate) {
    return <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`${classes} relative group`} {...props as any} data-id="element-212">
        <span className="absolute inset-0 rounded-full shadow-glow opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-213"></span>
        <span className="relative z-10" data-id="element-214">{children}</span>
      </motion.button>;
  }
  return <button className={classes} {...props} data-id="element-215">
      {children}
    </button>;
}